/* jshint browser: true */
/* global chrome */

function defaultEnvironment() {
  var env = {};
  if (typeof(window) !== 'undefined') {
    // Browser
    env.window = window;
  }
  if (typeof(chrome) !== 'undefined') {
    // Chrome Extension
    env.chrome = chrome;
  }
  if (typeof(process) !== 'undefined') {
    // NodeJS script
    env.process = process;
  }
  return env;
}

module.exports = defaultEnvironment;



//////////////////
// WEBPACK FOOTER
// ./node_modules/asana/lib/default_environment.js
// module id = 1484
// module chunks = 0